export default __webpack_public_path__ + "static/media/apple-appstore.e16ed416.svg";